import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const ConvertGraphic = () => {
  const data = useStaticQuery(graphql`
    query {
      convertGraphicImage: file(relativePath: { eq: "graphics/convert-graphic.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Img
      fluid={data.convertGraphicImage.childImageSharp.fluid}
      alt="Convert Graphic"
    />
  )
}

export default ConvertGraphic
